import { render, staticRenderFns } from "./Layout02.vue?vue&type=template&id=4db87286&"
import script from "./Layout02.vue?vue&type=script&lang=js&"
export * from "./Layout02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports